// Decodifica el payload de un JWT SIN verificar firma (solo lectura de claims).
// No usar para autorizar; solo para hidratar UI. La verificación la hace el backend.

export interface JwtClaims {
  userId?: string;
  email?: string;
  name?: string;
  role?: string;
  orgId?: string | null;
  jti?: string;
  iat?: number;
  exp?: number;
  [key: string]: unknown;
}

export function decodeJwt(token: string): JwtClaims | null {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    let b64 = part.replace(/-/g, '+').replace(/_/g, '/');
    b64 += '='.repeat((4 - (b64.length % 4)) % 4);
    const bytes = atob(b64);
    const utf8 = decodeURIComponent(
      bytes
        .split('')
        .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join(''),
    );
    return JSON.parse(utf8) as JwtClaims;
  } catch {
    return null;
  }
}
